import { render, staticRenderFns } from "./baozhuanggzMb.vue?vue&type=template&id=66750fd8&scoped=true&"
import script from "./baozhuanggzMb.vue?vue&type=script&lang=js&"
export * from "./baozhuanggzMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66750fd8",
  null
  
)

export default component.exports